// @ts-nocheck
import {
  Fragment,
  useEffect,
  useRef,
  useState,
  Ref,
  useMemo,
  useCallback,
} from "react";
import { useModelViewerStore } from "@/store/modelViewerStore";
import { SightlineVerifierResponse } from "@/types/sightlineVerifier";

import {
  roundToDecimals,
  vec3Distance,
  hexToRgbArray,
  getYAngleDegree,
  angleDifferenceABtoAC,
  wrapAngle,
  calculateTargetPosition,
  normalizeRotation,
} from "src/utils/game";
import * as pc from "playcanvas";
import { OrbitControls } from "@playcanvas/react/scripts";
import {
  useTexture,
  useMaterial,
  useEnvAtlas,
  useApp,
  useSplat,
  useModel,
  useAppEvent,
} from "@playcanvas/react/hooks";
import { Application, Entity, Gltf } from "@playcanvas/react";
import {
  Render,
  Camera,
  Light,
  GSplat,
  Script,
  Environment,
} from "@playcanvas/react/components";
import { CameraControls } from "playcanvas/scripts/esm/camera-controls.mjs";

import WatermarkScreen from "src/components/watermark";
import { useLodSplat } from "src/utils/useLodSplat";
import LottieLoading from "src/components/lottie/lottie-loading";

import { GsplatRevealRadial } from "src/extra_js/reveal-radial.mjs";

import {
  createRadialScript,
  createRadialScriptFast,
  SplatLodComponent,
  SplatSogComponent,
  RobotAvatar,
  MeshModelComponent,
  FloorMeshComponent,
  installCameraNearFar,
} from "@/components/playcanvas/playcanvasComponents";

import {
  IMapAlign,
  calculateXy,
  findMapAlignWithLcMapId,
  findMapAlignWithGisLevelId,
  getModelConfigMapByLcMapId,
  getVenueShortNameById,
  getMapAlignById,
  getAllFloorMapAlignByVenueId,
  getFloorMapAlignByLevelIndex,
  getVenueModelConfigByVenueCode,
  getBaseUrl,
  getVenueIdByVenueCode,
  getStartPointNameByVenueCode,
  getEndPointNameByVenueCode,
  getMapSettingByVenueId,
  getFloorIndexByFloorId,
} from "src/utils/map-util";

export default function SightlineVerifier() {
  const setProgress = useModelViewerStore((state) => state.setProgress);
  const setIsModelLoaded = useModelViewerStore(
    (state) => state.setIsModelLoaded,
  );
  const setErrorMessage = useModelViewerStore((state) => state.setErrorMessage);

  const setSightlineVerifierData = useModelViewerStore(
    (state) => state.setSightlineVerifierData,
  );

  const SCALE_BASE = 1500;

  // const [venueModelConfigState, setVenueModelConfigState] =
  //   useState<VenueModelConfig>(null);

  const [sightlineVerifierDataState, setSightlineVerifierDataState] =
    useState<SightlineVerifierResponse>(null);

  const [mapSettingState, setMapSettingState] = useState<IMapAlign>(null);

  const moveSpeedRef = useRef<number>(2);
  const rotateSpeedRef = useRef<number>(20);

  // const defaultPositionRef = useRef<pc.Vec3>(new pc.Vec3(0, 0, 0));
  // const defaultTargetRef = useRef<pc.Vec3>(new pc.Vec3(0, 0, -1));

  const targetAltitudeRef = useRef<number>(0);

  const latestCurrentLevelNameRef = useRef<string>("");
  const latestCurrentLevelIndexRef = useRef<number>(0);

  const mainObjectEntityRef = useRef();
  const cameraScriptRef = useRef();
  const firstPersonCameraEntityRef = useRef();
  const thirdPersonCameraEntityRef = useRef();
  const latestCameraModeRef = useRef<number>(0);

  const transitionTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(
    null,
  );

  const isMovingRef = useRef<boolean>(false);
  const isRotatingRef = useRef<boolean>(false);

  const latestPositionJoystickData = useRef<number[]>([0, 0]);
  const latestRotationJoystickData = useRef<number[]>([0, 0]);
  const latestRotationScreenData = useRef<number[]>([0, 0]);

  const latestResetPositionRotationEvent = useRef<number>(0);
  const latestResetOnlyRotationEvent = useRef<number>(0);

  const latestVenueModelConfigRef = useRef<VenueModelConfig | null>(null);

  const isInstantUpdate = useRef<boolean>(false);

  const latestModelJsonData = useRef<any>(null);

  const hiddenNearRef = useRef<pc.Entity>(null);
  const hiddenFarRef = useRef<pc.Entity>(null);

  const cameraArrayPosition = useRef([]);
  const cameraArrayTarget = useRef([]);

  const latestProgressRef = useRef(0);

  const eulerRef = useRef(new pc.Vec3(0, 0, 0));

  const currentLevelIndexRef = useRef<number>(0);

  const gsplatAllRef = useRef({});
  const splatDisplayFloor = useRef<number[]>();

  const revealEffectTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(
    null,
  );

  function interpolateVector3Array(points, percentage) {
    if (percentage <= 0) return points[0];
    if (percentage >= 1) return points[points.length - 1];

    const segments = points.length - 1;
    const scaledPosition = percentage * segments;
    const segmentIndex = Math.floor(scaledPosition);
    const segmentFraction = scaledPosition - segmentIndex;

    const start = points[segmentIndex];
    const end = points[segmentIndex + 1];

    return [
      start[0] + (end[0] - start[0]) * segmentFraction,
      start[1] + (end[1] - start[1]) * segmentFraction,
      start[2] + (end[2] - start[2]) * segmentFraction,
    ];
  }

  useEffect(() => {
    setIsModelLoaded(false);
    setErrorMessage("");
  }, []);

  function useQueryParams() {
    return useMemo(() => new URLSearchParams(window.location.search), []);
  }
  const DataController = () => {
    const sightlineVerifierData = useModelViewerStore(
      (state) => state.sightlineVerifierData,
    );
    useEffect(() => {
      if (!sightlineVerifierData) {
        return;
      }
      console.log("sightlineVerifierData", sightlineVerifierData);
      setSightlineVerifierDataState(sightlineVerifierData);
      const mapSetting = getMapSettingByVenueId(
        sightlineVerifierData[0]?.venueId,
      );
      setMapSettingState(mapSetting);
    }, [sightlineVerifierData]);

    const resetPositionRotationEvent = useModelViewerStore(
      (state) => state.resetPositionRotationEvent,
    );
    useEffect(() => {
      latestResetPositionRotationEvent.current = resetPositionRotationEvent;
    }, [resetPositionRotationEvent]);

    const resetOnlyRotationEvent = useModelViewerStore(
      (state) => state.resetOnlyRotationEvent,
    );
    useEffect(() => {
      latestResetOnlyRotationEvent.current = resetOnlyRotationEvent;
    }, [resetOnlyRotationEvent]);
    return <></>;
  };

  const MainCamera = () => {
    const app = useApp();
    const cameraRef = useRef();
    let _localProgress;
    let _localCameraMode;
    let isCameraModeUpdated;
    let nearestFixedCameraPosition;

    let finalCameraPosition;
    let finalCameraLookingPosition;

    app.on("update", function (dt) {
      if (cameraScriptRef.current == null) {
        return;
      }

      if (
        firstPersonCameraEntityRef.current == null ||
        thirdPersonCameraEntityRef.current == null
      ) {
        return;
      }

      isCameraModeUpdated = _localCameraMode != latestCameraModeRef.current;
      _localCameraMode = latestCameraModeRef.current;

      if (
        isInstantUpdate.current ||
        isCameraModeUpdated ||
        isMovingRef.current ||
        isRotatingRef.current
      ) {
        const newPosition =
          latestCameraModeRef.current == 0
            ? firstPersonCameraEntityRef.current.getPosition()
            : thirdPersonCameraEntityRef.current.getPosition();
        cameraScriptRef.current.reset(
          mainObjectEntityRef.current.getPosition(),
          newPosition,
        );

        isMovingRef.current = false;
        isRotatingRef.current = false;
        isInstantUpdate.current = false;
      }
    });

    useEffect(() => {
      const defaultCameraLookingPosition = new pc.Vec3(0, 0, 0);
      const defaultPosition = new pc.Vec3(0, 0, 0);
      cameraScriptRef.current.reset(
        defaultCameraLookingPosition,
        defaultPosition,
      );
      cameraScriptRef.current._camera.gammaCorrection = 1;
      cameraScriptRef.current._camera.toneMapping = 0;
      //cameraScriptRef.current._camera.toneMapping = pc.TONEMAP_ACES2;
      cameraScriptRef.current._camera.jitter = 0;
      cameraScriptRef.current._camera.shutter = 0;
    }, []);

    app.on("update", function (dt) {
      if (cameraScriptRef.current == null) {
        return;
      }
    });

    return (
      <Entity name="MainCamera">
        <Camera fov={75} clearColor="#000000" clearColorBuffer={true} />
        <Script
          ref={cameraScriptRef}
          script={CameraControls}
          enableFly={false}
        />
        <Entity ref={hiddenNearRef} position={[0, 0, 0]}></Entity>
        <Entity ref={hiddenFarRef} position={[0, 0, -0.5]}></Entity>
      </Entity>
    );
  };

  const setPositionTarget = (
    positionX: number,
    positionY: number,
    positionZ: number,
    targetX: number,
    targetY: number,
    targetZ: number,
  ) => {
    const newPosition = new pc.Vec3(-positionX, positionY, -positionZ);
    const newTarget = new pc.Vec3(-targetX, targetY, -targetZ);
    if (mainObjectEntityRef.current) {
      mainObjectEntityRef.current.setPosition(newPosition);
      mainObjectEntityRef.current.lookAt(newTarget);
      const initAngles = mainObjectEntityRef.current.getEulerAngles();
      if (initAngles.z < 90 && initAngles.z > -90) {
        eulerRef.current.set(initAngles.x, initAngles.y, 0);
      } else if (initAngles.z > 90 || initAngles.z < -90) {
        if (initAngles.x > 0) {
          eulerRef.current.set(initAngles.x - 180, 180 - initAngles.y, 0);
        } else {
          eulerRef.current.set(initAngles.x + 180, 180 - initAngles.y, 0);
        }
      } else {
        eulerRef.current.set(0, 0, 0);
      }
      isInstantUpdate.current = true;
    }
  };

  const MainObject = () => {
    const app = useApp();

    const adjustAltitude = (alt, height) => {
      return height === "bottom" ? alt - 6 : height === "top" ? alt + 6 : alt;
    };

    useEffect(() => {
      const sightlineItem = sightlineVerifierDataState[0];
      const thisMapAlign = findMapAlignWithGisLevelId(
        mapSettingState.floorAlignment,
        sightlineItem.levelId,
        [sightlineItem.from.lng, sightlineItem.from.lat]
      );

      const thisScaleFactor = SCALE_BASE / thisMapAlign.scale;

      const thisLcMapId = thisMapAlign.lcMapId;
      const modelConfigMap = getModelConfigMapByLcMapId(mapSettingState.modelConfig,thisLcMapId);
      const altitude = modelConfigMap.altitude;

      let fromAltitude = adjustAltitude(altitude, sightlineItem.from.height);
      let toAltitude = adjustAltitude(altitude, sightlineItem.to.height);

      const fromPositionXy = calculateXy(
        thisMapAlign,
        sightlineItem.from.lat,
        sightlineItem.from.lng,
      );
      console.log(fromPositionXy);
      const toPositionXy = calculateXy(
        thisMapAlign,
        sightlineItem.to.lat,
        sightlineItem.to.lng,
      );

      const newPosition = new pc.Vec3(
        -fromPositionXy.x / thisScaleFactor,
        fromAltitude / thisScaleFactor,
        -fromPositionXy.y / thisScaleFactor,
      );
      const newTarget = new pc.Vec3(
        -toPositionXy.x /thisScaleFactor,
        toAltitude / thisScaleFactor,
        -toPositionXy.y / thisScaleFactor,
      );

      mainObjectEntityRef.current.setPosition(newPosition);
      mainObjectEntityRef.current.lookAt(newTarget);
      const initAngles = mainObjectEntityRef.current.getEulerAngles();
      if (initAngles.z < 90 && initAngles.z > -90) {
        eulerRef.current.set(initAngles.x, initAngles.y, 0);
      } else if (initAngles.z > 90 || initAngles.z < -90) {
        if (initAngles.x > 0) {
          eulerRef.current.set(initAngles.x - 180, 180 - initAngles.y, 0);
        } else {
          eulerRef.current.set(initAngles.x + 180, 180 - initAngles.y, 0);
        }
      } else {
        eulerRef.current.set(0, 0, 0);
      }

      isInstantUpdate.current = true;
    }, []);

    app.on("update", function (dt) {
      if (mainObjectEntityRef.current == null) {
        return;
      }
      if (
        latestRotationScreenData.current[0] != 0 ||
        latestRotationScreenData.current[1] != 0
      ) {
        isRotatingRef.current = true;
        eulerRef.current.y +=
          -latestRotationScreenData.current[0] * rotateSpeedRef.current * dt; // Yaw
        eulerRef.current.x +=
          -latestRotationScreenData.current[1] * rotateSpeedRef.current * dt; // Pitch
        eulerRef.current.x = pc.math.clamp(eulerRef.current.x, -45, 45);
        eulerRef.current.y = wrapAngle(eulerRef.current.y);
        mainObjectEntityRef.current.setLocalEulerAngles(eulerRef.current);
      }
    });

    return (
      <Entity ref={mainObjectEntityRef}>
        {/*<Avatar />*/}
        <Entity
          ref={firstPersonCameraEntityRef}
          position={[0, 0, 0.001]}
        ></Entity>
        <Entity
          ref={thirdPersonCameraEntityRef}
          position={[0, 0.5, 4]}
        ></Entity>
      </Entity>
    );
  };

  const cleanup = (app, gsplatEntity) => {
    const cleanup = installCameraNearFar(
      app,
      gsplatEntity,
      hiddenNearRef.current,
      hiddenFarRef.current,
    );
    return cleanup;
  };

  const MeshModels = () => {
    const app = useApp();
    const baseUrl = getBaseUrl();
    return (
      <>
        {mapSettingState!.modelConfig!.mesh.meshModels.map((item, index) => (
          <Fragment key={item.index}>
            <MeshModelComponent
              app={app}
              cameraName={"MainCamera"}
              meshUrl={
                baseUrl + mapSettingState!.modelConfig!.folderPath + item.url
              }
              meshPosition={[
                item.position[0] / mapSettingState!.modelConfig!.scaleFactor,
                item.position[1] / mapSettingState!.modelConfig!.scaleFactor,
                item.position[2] / mapSettingState!.modelConfig!.scaleFactor,
              ]}
              meshRotationAngle={item.rotationAngle}
              meshScale={[
                item.scale[0] / mapSettingState!.modelConfig!.scaleFactor,
                item.scale[1] / mapSettingState!.modelConfig!.scaleFactor,
                item.scale[2] / mapSettingState!.modelConfig!.scaleFactor,
              ]}
              meshColor={item.color ?? "#FFFFFF"}
              meshOpacity={item.opacity ?? 1}
              rotateObjects={item.rotateObjects ?? []}
            />
          </Fragment>
        ))}
      </>
    );
  };

  const SingleLod = () => {
    const app = useApp();
    const baseUrl = getBaseUrl();
    const lodLink =
      baseUrl +
      mapSettingState!.modelConfig!.folderPath +
      mapSettingState!.modelConfig!.splat?.singleLod;
    const callbackReadyFunction = (splat, asset) => {
      gsplatAllRef.current["single"] = splat;
      console.log("single lod ready !!!!!!!!!");
      splat.gsplat.enabled = true;
      setIsModelLoaded(true);
      // enableXRayMode();
    };
    return (
      <SplatLodComponent
        app={app}
        url={lodLink}
        position={[0, 0, 0]}
        rotation={[180, 0, 0]}
        scale={[
          1 / mapSettingState!.modelConfig!.scaleFactor,
          1 / mapSettingState!.modelConfig!.scaleFactor,
          1 / mapSettingState!.modelConfig!.scaleFactor,
        ]}
        lodDistances={mapSettingState!.modelConfig!.scaleFactor}
        callbackReady={callbackReadyFunction}
      />
    );
  };

  const FloorLod = () => {
    console.log(mapSettingState!.modelConfig!.splat);
    return (
      <>
        {mapSettingState!.modelConfig!.floor.map((item, index) => (
          <Fragment key={index}>
            <EachFloorLod floorIndex={index} floorSetting={item} />
          </Fragment>
        ))}
      </>
    );
  };

  const EachFloorLod = ({ floorSetting }) => {
    const app = useApp();
    const baseUrl = getBaseUrl();
    const assetModel = useRef();
    const lodLink =
      baseUrl + mapSettingState!.modelConfig!.folderPath + floorSetting.lod;

    const mapAlign = findMapAlignWithLcMapId(
      mapSettingState.floorAlignment,
      floorSetting.lcMapId,
    );
    const scaleFactor = SCALE_BASE / mapAlign.scale;

    const handleUpdate = useCallback((dt: number) => {
      if (
        !gsplatAllRef.current[floorSetting.index] ||
        !gsplatAllRef.current[floorSetting.index].gsplat
      ) {
        return;
      }
      if (floorSetting.index == latestCurrentLevelIndexRef.current) {
        splatDisplayFloor.current = floorSetting.displayLod;
      }
      if (
        gsplatAllRef.current[floorSetting.index] == null ||
        splatDisplayFloor.current == null
      ) {
        return;
      }
      if (splatDisplayFloor.current.includes(floorSetting.index)) {
        gsplatAllRef.current[floorSetting.index].gsplat.enabled = true;
        gsplatAllRef.current[floorSetting.index].gsplat.asset =
          assetModel.current;
      } else {
        gsplatAllRef.current[floorSetting.index].gsplat.enabled = false;
        gsplatAllRef.current[floorSetting.index].gsplat.asset = null;
      }
    }, []);
    useAppEvent("update", handleUpdate);

    const callbackReadyFunction = (splat, asset) => {
      gsplatAllRef.current[floorSetting.index] = splat;
      assetModel.current = asset;
      splat.gsplat.enabled = true;
      setTimeout(() => {
        afterReady();
      }, 1000);
    };

    const afterReady = () => {
      console.log("afterReady");
      setIsModelLoaded(true);
      // enableXRayMode();
    };

    return (
      <SplatLodComponent
        app={app}
        url={lodLink}
        position={[
          0,
          floorSetting.yAxis / mapSettingState!.modelConfig!.scaleFactor,
          0,
        ]}
        rotation={[180, 0, 0]}
        scale={[
          1 / mapSettingState!.modelConfig!.scaleFactor,
          1 / mapSettingState!.modelConfig!.scaleFactor,
          1 / mapSettingState!.modelConfig!.scaleFactor,
        ]}
        lodDistances={mapSettingState!.modelConfig!.scaleFactor}
        callbackReady={callbackReadyFunction}
      />
    );
  };

  const Splat = () => {
    return (
      <>
        {mapSettingState!.modelConfig!.splat?.mode == "singleLod" ? (
          <SingleLod />
        ) : mapSettingState!.modelConfig!.splat?.mode == "floorLod" ? (
          <FloorLod />
        ) : (
          <></>
        )}
      </>
    );
  };

  const FloorMeshContainer = () => {
    const baseUrl = getBaseUrl();
    const floorMeshPosition = mapSettingState!.modelConfig!.floorMeshPosition;
    const floorMeshUrl =
      baseUrl +
      mapSettingState!.modelConfig!.folderPath +
      mapSettingState!.modelConfig!.floorMesh;
    return floorMeshUrl != "" ? (
      <FloorMeshComponent
        floorMeshUrl={floorMeshUrl}
        floorMeshPosition={[
          floorMeshPosition[0] / scaleFactor,
          floorMeshPosition[1] / scaleFactor,
          floorMeshPosition[2] / scaleFactor,
        ]}
        floorMeshScale={[
          1 / scaleFactor,
          1 / scaleFactor,
          1 / scaleFactor,
        ]}
      />
    ) : (
      <></>
    );
  };

  const PlaycanvasScene = () => {
    const app = useApp();
    const newProgress = useRef(0);
    app.graphicsDevice.maxPixelRatio = 2;
    return (
      <>
        {mapSettingState?.modelConfig?.splat ? <Splat /> : <></>}
        {mapSettingState?.modelConfig?.mesh ? <MeshModels /> : <></>}
        {mapSettingState?.modelConfig?.floorMesh ? (
          <FloorMeshContainer />
        ) : (
          <></>
        )}
        {sightlineVerifierDataState && mapSettingState ? <MainObject /> : <></>}
        <MainCamera />
      </>
    );
  };

  const Scene = () => {
    return (
      <Application
        usePhysics={false}
        maxDeltaTime={0.033}
        graphicsDeviceOptions={{
          alpha: true,
          antialias: false,
          depth: true,
          stencil: false,
          powerPreference: "high-performance",
        }}
      >
        <PlaycanvasScene />
      </Application>
    );
  };

  const Loading = () => {
    const isModelLoaded = useModelViewerStore((state) => state.isModelLoaded);
    return !isModelLoaded ? (
      <div className="frosted-fullscreen flex flex-col items-center justify-center">
        <LottieLoading />
      </div>
    ) : (
      <></>
    );
  };

  const ErrorMessage = () => {
    const errorMessage = useModelViewerStore((state) => state.errorMessage);
    return errorMessage != "" ? (
      <div className="frosted-fullscreen flex flex-col items-center justify-center">
        {errorMessage}
      </div>
    ) : (
      <></>
    );
  };

  console.log(
    "Model Viewer Page component rendered , if this keep showing, something wrong",
  );

  const DragController = () => {
    const isDraggingRef = useRef(false);
    const startPosRef = useRef({ x: 0, y: 0 });
    const previousPositionRef = useRef({ x: 0, y: 0 });
    const getClientPos = (e) => {
      if (e.touches && e.touches.length > 0) {
        return { x: e.touches[0].clientX, y: e.touches[0].clientY };
      }
      return { x: e.clientX, y: e.clientY };
    };
    const handleStart = useCallback((e) => {
      const pos = getClientPos(e);
      isDraggingRef.current = true;
      previousPositionRef.current = { x: pos.x, y: pos.y };
    }, []);
    const handleMove = useCallback((e) => {
      if (!isDraggingRef.current) {
        return;
      }
      const pos = getClientPos(e);
      const xChange = pos.x - previousPositionRef.current.x;
      const yChange = pos.y - previousPositionRef.current.y;
      previousPositionRef.current = { x: pos.x, y: pos.y };
      latestRotationScreenData.current[0] = xChange * 0.5;
      latestRotationScreenData.current[1] = yChange * 0.5;
    }, []);
    const handleEnd = useCallback(() => {
      isDraggingRef.current = false;
      latestRotationScreenData.current[0] = 0;
      latestRotationScreenData.current[1] = 0;
    }, []);
    useEffect(() => {
      window.addEventListener("mouseup", handleEnd);
      window.addEventListener("touchend", handleEnd);
      return () => {
        window.removeEventListener("mouseup", handleEnd);
        window.removeEventListener("touchend", handleEnd);
      };
    }, []);

    return (
      <div
        className="fullscreen_div"
        onMouseDown={handleStart}
        onTouchStart={handleStart}
        onMouseMove={handleMove}
        onTouchMove={handleMove}
        onMouseUp={handleEnd}
        onTouchEnd={handleEnd}
      ></div>
    );
  };

  return (
    <div
      className="absolute top-0 left-0 w-full h-full"
      style={{ backgroundColor: "black" }}
    >
      <Loading />
      <ErrorMessage />
      <DataController />
      <Scene />
      <DragController />
      <WatermarkScreen />
    </div>
  );
}
